module.exports = __webpack_public_path__ + "static/media/us.f1214c6c.svg";